<header class="header-serasa" id="id-header">
  <div class="container">
    <div class="institucional">
      <div class="logo">
        <a routerLink="/"></a>
        <img src="assets/logo-serasa-consumidor.svg" alt="Logo Serasa">
      </div>
      <h1 class="hidden-mobile" id="header-title">Proteção de dados pessoais</h1>
    </div>
    <div class="info-menu hidden-mobile">
      <span class="line"></span>
      <div class="menu-item">
        <div class="expand" id="menu-you-need-lnk" (click)="menuProdutosActive = !menuProdutosActive">O que você precisa
        <i class="show-more"></i>
        </div>
        <div class="menu-produtos" [ngClass]="{on: menuProdutosActive == true}">
          <div class="left">
            <nav aria-label="menu">
              <ul>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="CPF">
                  <a href="https://www.serasa.com.br/consultar-meu-cpf">Consultar meu CPF</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Empréstimo On-line">
                  <a href="https://www.serasa.com.br/ecred">Pedir empréstimo on-line</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Consultar Score">
                  <a href="https://www.serasa.com.br/score">Consultar pontuação do Score</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Monitorar CPF">
                  <a href="https://www.serasa.com.br/antifraude">Monitorar meu CPF</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Limpar Nome">
                  <a href="https://www.serasa.com.br/limpa-nome-online">Limpar meu nome</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Negociar Dívidas">
                  <a href="https://www.serasa.com.br/limpa-nome-online">Negociar minhas dívidas</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Falar com a Serasa">
                  <a href="https://www.serasa.com.br/atendimento">Falar com a Serasa</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Atualizar dados">
                  <a href="https://www.serasa.com.br/meus-dados/alterar-dados/">Atualizar meus dados</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Soluções para empresas">
                  <a href="https://www.serasaexperian.com.br/">Soluções para empresas</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="right">
            <h4>Produtos</h4>
            <ul>
              <li>
                <a href="https://www.serasa.com.br/ecred">
                  <img src="assets/produto-ecred.svg" class="icon" alt="Ilustração (Logotipo Serasa eCred)"/>
                  <span class="text">Serasa eCred</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/antifraude">
                  <img src="assets/produto-antifraude.svg" class="icon" alt="Ilustração (Logotipo Serasa Antifraude)"/>
                  <span class="text">Serasa Antifraude</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/limpa-nome-online">
                  <img src="assets/produto-limpa-nome.svg" class="icon" alt="Ilustração (Logotipo Serasa Limpa Nome)"/>
                  <span class="text">Serasa Limpa Nome</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/score">
                  <img src="assets/produto-score.svg" class="icon" alt="Ilustração (Logotipo Serasa Score)"/>
                  <span class="text">Serasa Score</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/cadastro-positivo">
                  <img src="assets/produto-cadastro-positivo.svg" class="icon" alt="Ilustração (Logotipo Serasa Cadastro Positivo)"/>
                  <span class="text">Serasa Cadastro Positivo</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/ensina">
                  <img src="assets/produto-ensina.svg" class="icon" alt="Ilustração (Logotipo Serasa Ensina)"/>
                  <span class="text">Serasa Ensina</span>
                </a>
              </li>
              <li>
                <a href="https://www.serasa.com.br/voceconsulta">
                  <img src="assets/produto-vcep.svg" class="icon" alt="Ilustração (Logotipo Você consulta)"/>
                  <span class="text">Você Consulta</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span class="line"></span>
      <div class="menu-item user" *ngIf="!loginError">
        <div class="title">
          <span id="header-user-title">Confidencial para<br> </span>
          <strong id="header-user-full-name">{{userData.fullName}}</strong>
        </div>
        <div class="avatar" *ngIf="profileImage == '' || profileImage == null || profileImage == false">
          {{firstLetterName}}
        </div>
        <div class="avatar-img" [style.background-image]="'url(' + profileImage + ')'" *ngIf="profileImage !== '' || profileImage !== null || profileImage !== false"></div>
        <i class="show-more" id="user-show-more"(click)="menuUserActive = !menuUserActive"></i>
        <div class="menu-user" id="user-menu" [ngClass]="{on: menuUserActive == true}">
          <div class="left">
            <nav aria-label="links">
              <ul>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Meu perfil">
                  <a id="user-menu-profile-lnk" href="https://www.serasa.com.br/meu-perfil/">Meu Perfil</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Editar dados">
                  <a id="user-menu-edit-lnk" href="https://www.serasa.com.br/meus-dados/alterar-dados/">Editar dados</a>
                </li>
                <li>
                  <img src="assets/icon-menu-angle-right.svg" alt="Sair">
                  <a id="user-menu-logout-lnk" (click)="resetStorage()">Sair</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <button class="btn-login" id="btn-user-login" (click)="redirectPaginaLogin()" *ngIf="loginError" >Entrar</button>
    </div>
    <button class="menu-mobile-btn show-mobile-only" (click)="menuMobileActive = !menuMobileActive">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</header>
<app-mobile-menu [menuIsOpen]="menuMobileActive"></app-mobile-menu>
